import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { LabelModal } from '../../theme/styles';
import './LoadingBar.css';

export const LoadingBar = ({ loadingProgressData }) => {
    const percentLabel = `${Math.floor((((loadingProgressData?.progress || 0) / (loadingProgressData?.maxValue || 1)) * 100))}%`;

    return (
        <div className="progressBarWrapper">
            <div className="progressBarMessage" style={LabelModal}>
                {loadingProgressData?.message || ''}
            </div>
            <ProgressBar
                className="loadingBar"
                animated
                variant={loadingProgressData?.barVariant || null}
                min={loadingProgressData?.minValue || 0}
                max={loadingProgressData?.maxValue || 100}
                now={loadingProgressData?.progress || 0}
                label={percentLabel}
            />
        </div>
    );
};

export default LoadingBar;
